const BRANCH_ACTIONS = {
  //get branch
  GET_BRANCH_REQUEST: "GET_BRANCH_REQUEST",
  GET_BRANCH_SUCCESS: "GET_BRANCH_SUCCESS",
  GET_BRANCH_FAIL: "GET_BRANCH_FAIL",
  //get authorities
  GET_AUTHORITIES_REQUEST: "GET_AUTHORITIES_REQUEST",
  GET_AUTHORITIES_SUCCESS: "GET_AUTHORITIES_SUCCESS",
  GET_AUTHORITIES_FAIL: "GET_AUTHORITIES_FAIL",
  //post new branch
  POST_BRANCH: "POST_BRANCH",
  POST_BRANCH_SUCCESS: "POST_BRANCH_SUCCESS",
  POST_BRANCH_FAIL: "POST_BRANCH_FAIL",
  //delete branch
  DELETE_BRANCH: "DELETE_BRANCH",
  DELETE_BRANCH_SUCCESS: "DELETE_BRANCH_SUCCESS",
  DELETE_BRANCH_FAIL: "DELETE_BRANCH_FAIL",
  //update branch
  UPDATE_BRANCH: "UPDATE_BRANCH",
  UPDATE_BRANCH_SUCCESS: "UPDATE_BRANCH_SUCCESS",
  UPDATE_BRANCH_FAIL: "UPDATE_BRANCH_FAIL",
  ///change branch
  CHANGE_BRANCH_SUCCESS: "CHANGE_BRANCH_SUCCESS",
};
export default BRANCH_ACTIONS;
